import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";
import logo from "assets/img/logos/logoNew.png";

const Logo = ({ at, width, className, textClass, ...rest }) => {
  return (
    <Link
      to="#"
      className={classNames(
        "text-decoration-none logo-hover",
        { "navbar-brand text-left": at === "navbar-vertical" },
        { "navbar-brand text-left": at === "navbar-top" }
      )}
      {...rest}
      style={{ padding: "14.5px", paddingRight: "14px" }}
    >
      <div
        className={classNames(
          "d-flex",
          {
            "align-items-center": at === "navbar-vertical",
            "align-items-center": at === "navbar-top",
            "flex-center fw-bolder fs-4 mb-4": at === "auth",
          },
          className
        )}
      >
        <img
          className=""
          src={logo}
          alt="Logo"
          width={width}
          style={{ marginLeft: "2px" }}
        />
        {/* <span className={classNames("font-sans-serif", textClass)}>Intx</span> */}
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(["navbar-vertical", "navbar-top", "auth"]),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string,
};

Logo.defaultProps = { at: "auth", width: 58 };

export default Logo;
